module.exports = __webpack_public_path__ + "img/顶部栏.6e7a3f70.png";